var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanliDersler = function SvgCanliDersler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_4047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285 196.891L285 103.774C285 88.131 267.851 78.5435 254.525 86.7362L179.467 132.883C166.826 140.655 166.753 159.002 179.332 166.874L254.39 213.845C267.711 222.181 285 212.605 285 196.891Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 85.3608C16 60.3087 36.2964 40 61.3333 40H174.667C199.704 40 220 60.3087 220 85.3608V214.639C220 239.691 199.704 260 174.667 260H61.3333C36.2964 260 16 239.691 16 214.639V85.3608Z",
    fill: "url(#paint0_linear_4330_4047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 118C76.5391 118 94 100.539 94 79C94 57.4609 76.5391 40 55 40C33.4609 40 16 57.4609 16 79C16 100.539 33.4609 118 55 118Z",
    fill: "#2B81FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4047",
    x1: 219.965,
    y1: 40.0101,
    x2: 0.634472,
    y2: 243.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_4047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
export default SvgCanliDersler;